// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {zhLocale} from "./zh.js"
import { enLocale } from './en.js';

Vue.use(VueI18n);

// 配置不同语言的内容
const messages = {
  en: {
    message: {
      hello: 'Hello world!',
    },
    ...enLocale
  },
  zh: {
    message: {
      hello: '你好，世界！',
    },
    ...zhLocale
  },
};

// 创建 VueI18n 实例
const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  messages, // 语言内容
});

export default i18n;
